import { jsx, jsxs } from "react/jsx-runtime";
const FacebookIcon = ({ fill }) => {
  return /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", viewBox: "0 0 36 36", children: /* @__PURE__ */ jsxs("g", { "data-name": "Group 3111", transform: "translate(-1420 -11590)", children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        "data-name": "Ellipse 16",
        cx: "18",
        cy: "18",
        r: "18",
        transform: "translate(1420 11590)",
        style: { fill: fill || "#181d56" }
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        "data-name": "facebook (6)",
        d: "M15.5 3.263h2.08V.138A32.774 32.774 0 0 0 14.55 0C11.551 0 9.5 1.627 9.5 4.618V7.37H6.187v3.494H9.5v8.79h4.058v-8.789h3.172l.5-3.494h-3.677V4.964c0-1.01.316-1.7 1.947-1.7z",
        transform: "translate(1425.931 11598.173)",
        style: { fill: "#fff" }
      }
    )
  ] }) });
};
export {
  FacebookIcon
};
//# sourceMappingURL=footer_facebook.js.map
